export const beginWithLettersThenNumbersAndLetters = new RegExp(/^[a-zA-Z][\w]*$/g);

export const beginWithLettersThenNumbersAndLettersWithoutUnderscore = new RegExp(
  /^[a-zA-Z][a-zA-Z0-9]*$/,
);

export const noWhitespace = new RegExp(/^\S*$/);

export const noWhitespaceAtTheBeginning = new RegExp(/^[^\s].*/);

export const noWhitespaceAtTheBeginningAndEnd = new RegExp(/^(?!\s)(?!.*\s$).*$|^$/);

//isostring like: "2025-11-27T01:02:00.000Z"
export const ISO_DATE_REGEX =
  /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2})?(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/;
